"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COL_PROPS_PARAMS = exports.COL_ALIGNMENT_PROPS = exports.COL_PROPS = exports.ROW_ALIGNMENT_PROPS = exports.MEDIA_SIZES = exports.CHECKBOX_TYPES = exports.ORDER_TYPES = exports.DIRECTION_ALL = exports.DIRECTION_VERTICAL = exports.DIRECTION_HORIZONTAL = exports.TEXT_TRANSFORMS = exports.TEXT_ALIGNS = void 0;
var TEXT_ALIGNS = ['left', 'right', 'center', 'justify'];
exports.TEXT_ALIGNS = TEXT_ALIGNS;
var TEXT_TRANSFORMS = ['lowerCase', 'upperCase', 'capitalize'];
exports.TEXT_TRANSFORMS = TEXT_TRANSFORMS;
var DIRECTION_HORIZONTAL = ['left', 'right'];
exports.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
var DIRECTION_VERTICAL = ['top', 'bottom'];
exports.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
var DIRECTION_ALL = ['horizontal', 'vertical'].concat(DIRECTION_HORIZONTAL, DIRECTION_VERTICAL);
exports.DIRECTION_ALL = DIRECTION_ALL;
var ORDER_TYPES = ['first', 'last'];
exports.ORDER_TYPES = ORDER_TYPES;
var CHECKBOX_TYPES = ['radio', 'checkbox', 'toggle', 'special']; // row column

exports.CHECKBOX_TYPES = CHECKBOX_TYPES;
var MEDIA_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
exports.MEDIA_SIZES = MEDIA_SIZES;
var ROW_ALIGNMENT_PROPS = ['around', 'between', 'start', 'center', 'end', 'top', 'middle', 'bottom'];
exports.ROW_ALIGNMENT_PROPS = ROW_ALIGNMENT_PROPS;
var COL_PROPS = ['offset', 'order'];
exports.COL_PROPS = COL_PROPS;
var COL_ALIGNMENT_PROPS = ['top', 'middle', 'bottom', 'stretch'];
exports.COL_ALIGNMENT_PROPS = COL_ALIGNMENT_PROPS;
var COL_PROPS_PARAMS = ['hide', 'auto'];
exports.COL_PROPS_PARAMS = COL_PROPS_PARAMS;